(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('text-xml', {
            parent: 'entity',
            url: '/text-xml?page&sort&search',
            data: {
                authorities: ["ROLE_FONT_XML"],
                pageTitle: 'backApp.title.textXml'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/text-xml/text-xml.html',
                    controller: 'TextXmlController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clipArt');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('text-xml-approve', {
            parent: 'text-xml',
            url: '/approve/{id}',
            data: {
                authorities: ["ROLE_FONT_XML"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/text-xml/modal/text-xml-approve.html',
                    controller: 'TextXmlApproveController',
                    controllerAs: 'vm',
                    windowClass:'modal-right',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FontXmls'  , function(FontXmls) {
                            return FontXmls.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('text-xml', null, { reload: 'text-xml' });
                }, function() {
                    $state.go('text-xml');
                });
            }]
        });
    }

})();
